<ng-container *ngIf="!isCookieAgreed">
  <div id="cookie-overlay"></div>

  <section class="cookie-law-wrapper">
    <article>
      <main>
        <h2>{{ cookieBannerTitle | transloco }}</h2>
        <p
          *ngIf="!areCookieSettingsEnabled; else showSettings"
          [innerHTML]="'cookie.banner.text' | transloco"></p>

        <ng-template #showSettings>
          <ui-platform-switch
            [(ngModel)]="isNecessaryChecked"
            [disabled]="true"
            [label]="'cookie.banner.necessary' | transloco"></ui-platform-switch>
          <ui-platform-switch [label]="'cookie.banner.marketing' | transloco"></ui-platform-switch>
          <ui-platform-switch [label]="'cookie.banner.analytical' | transloco"></ui-platform-switch>
        </ng-template>
      </main>

      <aside class="buttons-row">
        <ui-platform-button
          type="secondary"
          label="{{ 'cookie.banner.settings-button' | transloco }}"
          *ngIf="!areCookieSettingsEnabled; else returnButton"
          (click)="toggleCookieSettings()">
        </ui-platform-button>
        <ng-template #returnButton>
          <ui-platform-button
            type="secondary"
            label="{{ 'cookie.banner.return' | transloco }}"
            (click)="toggleCookieSettings()">
          </ui-platform-button>
        </ng-template>

        <ui-platform-button
          type="secondary"
          label="{{ 'cookie.banner.only-necessary' | transloco }}"
          *ngIf="!areCookieSettingsEnabled; else saveButton"
          (click)="acceptCookieLaw(false, true)">
        </ui-platform-button>
        <ng-template #saveButton>
          <ui-platform-button
            type="primary"
            label="{{ 'cookie.banner.save-preferences' | transloco }}"
            (click)="acceptCookieLaw(false)">
          </ui-platform-button>
        </ng-template>

        <ui-platform-button
          type="primary"
          label="{{ 'cookie.banner.accept-all' | transloco }}"
          (click)="acceptCookieLaw(true)">
        </ui-platform-button>
      </aside>
    </article>
  </section>
</ng-container>
